module.exports = __webpack_public_path__ + "img/update_user.b4da0611.png";